'use client'

export default function AdvantageSection() {
  return (
    <div id="features" className="bg-gradient-to-b from-background-100 to-white py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mb-16 text-center">
          <h2 className="text-base font-semibold text-primary-500 tracking-wide uppercase">
            Powerful Features
          </h2>
          <p className="mt-2 text-4xl font-extrabold tracking-tight text-text-700 sm:text-5xl">
            The <span className="text-accent-500">ScanMaadi</span> Advantage
          </p>
          <p className="mt-4 max-w-2xl text-xl text-text-500 mx-auto">
            Modern features that delight your customers and simplify your life
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:mt-16 lg:grid-cols-3 lg:grid-rows-2">
          {/* Easy Search - Left tall card */}
          <div className="relative lg:row-span-2">
            <div className="absolute inset-px rounded-lg bg-white lg:rounded-l-[2rem]"></div>
            <div className="relative flex h-full flex-col overflow-hidden rounded-xl lg:rounded-l-[2rem]">
              <div className="px-8 pt-8 pb-3 sm:px-10 sm:pt-10 sm:pb-0">
                <div className="h-12 w-12 rounded-md bg-primary-500 text-white flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                  </svg>
                </div>
                <p className="text-lg font-medium tracking-tight text-text-700 max-lg:text-center">
                  Easy Search
                </p>
                <p className="mt-2 max-w-lg text-base text-text-500 max-lg:text-center">
                  Customer types "Paneer", sees all paneer dishes in a flash. No more squinting at tiny text or flipping pages.
                </p>
              </div>
              <div className="relative min-h-[24rem] w-full grow max-lg:mx-auto max-lg:max-w-sm">
                <div className="absolute inset-x-10 top-10 bottom-0 overflow-hidden rounded-t-xl border-x-[3px] border-t-[3px] border-text-700 bg-text-800 shadow-2xl">
                  <div className="p-4 bg-primary-500 flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="white" className="w-5 h-5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                    </svg>
                    <div className="ml-2 bg-white/20 rounded-full px-4 py-1 text-sm text-white">
                      Search for "paneer"
                    </div>
                  </div>
                  <div className="p-3 space-y-3">
                    <div className="bg-text-700 p-3 rounded-lg">
                      <div className="text-white font-medium">Paneer Butter Masala</div>
                      <div className="text-gray-300 text-sm mt-1">₹220 • Creamy tomato gravy with paneer cubes</div>
                    </div>
                    <div className="bg-text-700 p-3 rounded-lg">
                      <div className="text-white font-medium">Kadai Paneer</div>
                      <div className="text-gray-300 text-sm mt-1">₹200 • Spicy paneer with bell peppers</div>
                    </div>
                    <div className="bg-text-700 p-3 rounded-lg">
                      <div className="text-white font-medium">Palak Paneer</div>
                      <div className="text-gray-300 text-sm mt-1">₹180 • Spinach gravy with soft paneer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pointer-events-none absolute inset-px rounded-lg shadow-sm ring-1 ring-black/5 lg:rounded-l-[2rem]"></div>
          </div>

          {/* One-Tap Filters - Top right small card */}
          <div className="relative max-lg:row-start-1">
            <div className="absolute inset-px rounded-lg bg-white max-lg:rounded-t-[2rem]"></div>
            <div className="relative flex h-full flex-col overflow-hidden rounded-xl max-lg:rounded-t-[2rem]">
              <div className="px-8 pt-8 sm:px-10 sm:pt-10">
                <div className="h-12 w-12 rounded-md bg-accent-500 text-white flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z" />
                  </svg>
                </div>
                <p className="mt-2 text-lg font-medium tracking-tight text-text-700 max-lg:text-center">One-Tap Filters</p>
                <p className="mt-2 max-w-lg text-base text-text-500 max-lg:text-center">
                  Only Veg? Spicy? Below ₹150? Your customers can sort instantly with a single tap.
                </p>
              </div>
              <div className="flex flex-1 items-center justify-center px-8 py-6 max-lg:pt-10 max-lg:pb-12 sm:px-10">
                <div className="flex space-x-2 flex-wrap justify-center gap-2">
                  <div className="bg-primary-100 text-primary-700 px-4 py-2 rounded-full text-sm font-medium flex items-center">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" />
                      <circle cx="12" cy="12" r="4" fill="currentColor" />
                    </svg>
                    Veg Only
                  </div>
                  <div className="bg-accent-100 text-accent-700 px-4 py-2 rounded-full text-sm font-medium flex items-center">
                    <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
                    </svg>
                    Spicy
                  </div>
                  <div className="bg-highlight-100 text-highlight-700 px-4 py-2 rounded-full text-sm font-medium flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4 mr-1">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 8.25H9m6 3H9m3 6-3-3h1.5a3 3 0 1 0 0-6M12 19.5v-1.5" />
                    </svg>
                    Under ₹150
                  </div>
                </div>
              </div>
            </div>
            <div className="pointer-events-none absolute inset-px rounded-lg shadow-sm ring-1 ring-black/5 max-lg:rounded-t-[2rem]"></div>
          </div>

          {/* Instant Updates - Middle right small card */}
          <div className="relative max-lg:row-start-3 lg:col-start-2 lg:row-start-2">
            <div className="absolute inset-px rounded-lg bg-white"></div>
            <div className="relative flex h-full flex-col overflow-hidden rounded-xl">
              <div className="px-8 pt-8 sm:px-10 sm:pt-10">
                <div className="h-12 w-12 rounded-md bg-highlight-400 text-white flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 0 1 0 1.953l-7.108 4.062A1.125 1.125 0 0 1 3 16.81V8.688ZM12.75 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 0 1 0 1.953l-7.108 4.062a1.125 1.125 0 0 1-1.683-.977V8.688Z" />
                  </svg>
                </div>
                <p className="mt-2 text-lg font-medium tracking-tight text-text-700 max-lg:text-center">Instant Updates</p>
                <p className="mt-2 max-w-lg text-base text-text-500 max-lg:text-center">
                  Changed a price? Out of stock? Goes live instantly—no reprints needed!
                </p>
              </div>
              <div className="flex flex-1 items-center justify-center p-6">
                <div className="relative w-full max-w-xs">
                  <div className="absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full bg-highlight-400 text-white text-xs font-bold animate-pulse">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                      <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                    </svg>
                  </div>
                  <div className="border border-background-300 rounded-lg p-4 bg-white shadow-sm">
                    <div className="text-sm text-text-500 mb-1">Update Menu Item:</div>
                    <div className="flex items-center justify-between mb-2">
                      <div className="font-medium text-text-700">Masala Dosa</div>
                      <div className="flex items-center">
                        <span className="line-through text-text-400 mr-1">₹120</span>
                        <span className="text-accent-600 font-bold">₹99</span>
                      </div>
                    </div>
                    <div className="flex justify-end">
                      <div className="text-xs text-highlight-600 font-medium">Updated just now</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pointer-events-none absolute inset-px rounded-lg shadow-sm ring-1 ring-black/5"></div>
          </div>

          {/* Multiple Languages - Right tall card */}
          <div className="relative lg:row-span-2">
            <div className="absolute inset-px rounded-lg bg-white max-lg:rounded-b-[2rem] lg:rounded-r-[2rem]"></div>
            <div className="relative flex h-full flex-col overflow-hidden rounded-xl max-lg:rounded-b-[2rem] lg:rounded-r-[2rem]">
              {/* Coming Soon badge */}
              <div className="absolute top-4 right-4 z-10 px-3 py-1 bg-highlight-400 text-text-700 text-xs font-semibold rounded-full shadow uppercase tracking-wider">
                Coming Soon
              </div>
              <div className="px-8 pt-8 pb-3 sm:px-10 sm:pt-10 sm:pb-0">
                <div className="h-12 w-12 rounded-md bg-primary-600 text-white flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802" />
                  </svg>
                </div>
                <p className="mt-2 text-lg font-medium tracking-tight text-text-700 max-lg:text-center">
                  Multiple Languages
                </p>
                <p className="mt-2 max-w-lg text-base text-text-500 max-lg:text-center">
                  Menu auto-switches between Kannada, Hindi, English—customers love the localization!
                </p>
              </div>
              <div className="relative min-h-[24rem] w-full grow p-6">
                <div className="relative mx-auto max-w-sm">
                  <div className="rounded-xl bg-gradient-to-br from-primary-500 to-primary-600 p-1 shadow-xl">
                    <div className="rounded-lg bg-white p-3">
                      <div className="flex justify-between mb-4">
                        <div className="flex space-x-2">
                          <button className="px-3 py-1 bg-primary-600 text-white text-sm font-medium rounded-full">English</button>
                          <button className="px-3 py-1 bg-background-100 text-text-700 text-sm font-medium rounded-full">हिंदी</button>
                          <button className="px-3 py-1 bg-background-100 text-text-700 text-sm font-medium rounded-full">ಕನ್ನಡ</button>
                        </div>
                      </div>

                      <div className="divide-y divide-background-200">
                        <div className="py-3">
                          <div className="flex justify-between">
                            <div>
                              <h3 className="font-medium text-text-700">Masala Dosa</h3>
                              <p className="text-sm text-text-500">Crispy rice crepe with spiced potato filling</p>
                            </div>
                            <div className="font-medium text-primary-600">₹99</div>
                          </div>
                        </div>

                        <div className="py-3">
                          <div className="flex justify-between">
                            <div>
                              <h3 className="font-medium text-text-700">Filter Coffee</h3>
                              <p className="text-sm text-text-500">South Indian style brewed coffee</p>
                            </div>
                            <div className="font-medium text-primary-600">₹40</div>
                          </div>
                        </div>

                        <div className="py-3">
                          <div className="flex justify-between">
                            <div>
                              <h3 className="font-medium text-text-700">Idli Sambar</h3>
                              <p className="text-sm text-text-500">Steamed rice cakes with lentil soup</p>
                            </div>
                            <div className="font-medium text-primary-600">₹80</div>
                          </div>
                        </div>

                        <div className="py-3">
                          <button className="w-full text-center py-2 bg-background-100 rounded-lg text-sm font-medium text-text-700 hover:bg-background-200">
                            View Full Menu
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pointer-events-none absolute inset-px rounded-lg shadow-sm ring-1 ring-black/5 max-lg:rounded-b-[2rem] lg:rounded-r-[2rem]"></div>
          </div>
        </div>
      </div>
    </div>
  )
}